module.exports = __webpack_public_path__ + "static/media/Customer2.d8b4bef3.jpg";